import { Component } from '@angular/core';
import { InputComponent } from 'angular6-json-schema-form';
import { COLORS } from './widget-color.const';

@Component({
  selector: 'app-widget-color',
  templateUrl: './widget-color.component.html',
  styleUrls: ['./widget-color.component.scss'],
})
export class WidgetColorComponent extends InputComponent {
  public colors = COLORS;
  public colorNames = Object.keys(this.colors);

  public updateValue(event: { target: { value: string } }) {
    if (this.boundControl) {
      this.formControl.setValue(event.target.value);
    } else {
      super.updateValue(event);
    }
  }

  public displayedColor() {
    const colorName = this.colorNames.find(
      (color) => this.controlValue === this.colors[color]
    );
    return colorName ? colorName : '';
  }
}
